import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Redirects all /fr/* routes to their English equivalents.
 * French routes were removed — this ensures no 404s for old indexed URLs.
 */
const FrenchRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    
    // Map known French routes to English equivalents
    const frenchToEnglish: Record<string, string> = {
      '/fr': '/',
      '/fr/': '/',
      '/fr/blog': '/blog',
      '/fr/comparison': '/comparison',
      '/fr/comparison/hubspot': '/comparison/hubspot',
      '/fr/comparison/salesforce-einstein': '/comparison/salesforce-einstein',
      '/fr/a-propos': '/about',
      '/fr/tarifs': '/pricing',
      '/fr/essai': '/trial',
      '/fr/documentation': '/docs',
      '/fr/faq': '/faq',
      '/fr/politique-confidentialite': '/privacy-policy',
      '/fr/confidentialite-ue': '/privacy-eu',
      '/fr/conditions-utilisation': '/terms-of-service',
      '/fr/agent-ia-salesforce': '/ai-agent-salesforce',
    };

    // Check exact match first
    if (frenchToEnglish[path]) {
      navigate(frenchToEnglish[path], { replace: true });
      return;
    }

    // For /fr/blog/* routes, strip /fr prefix and redirect
    if (path.startsWith('/fr/blog/')) {
      const englishPath = path.replace(/^\/fr/, '');
      navigate(englishPath, { replace: true });
      return;
    }

    // For any other /fr/* route, strip /fr and try the English version
    const strippedPath = path.replace(/^\/fr\/?/, '/') || '/';
    navigate(strippedPath, { replace: true });
  }, [location.pathname, navigate]);

  return null;
};

export default FrenchRedirect;
